{
  "actionbar.actions": "Veiksmai",
  "actionbar.actionsAvailable": "Galimi veiksmai.",
  "actionbar.clearSelection": "Išvalyti pasirinkimą",
  "actionbar.selected": "Pasirinkta: {count}",
  "actionbar.selectedAll": "Pasirinkta viskas",
  "breadcrumbs.more": "Daugiau elementų",
  "button.pending": "laukiama",
  "calendar.invalidSelection": "{selectedCount, plural, one {Datos} other {Datų}} pasirinkimas negalimas.",
  "combobox.noResults": "Rezultatų nėra",
  "contextualhelp.help": "Žinynas",
  "contextualhelp.info": "Informacija",
  "datepicker.endTime": "Pabaigos laikas",
  "datepicker.startTime": "Pradžios laikas",
  "datepicker.time": "Laikas",
  "dialog.alert": "Įspėjimas",
  "dialog.dismiss": "Atmesti",
  "dropzone.replaceMessage": "Pašalinkite failą, kad pakeistumėte",
  "inlinealert.informative": "Informacija",
  "inlinealert.negative": "Klaida",
  "inlinealert.notice": "Įspėjimas",
  "inlinealert.positive": "Sėkmingai",
  "label.(optional)": "(pasirenkama)",
  "label.(required)": "(privaloma)",
  "menu.moreActions": "Daugiau veiksmų",
  "notificationbadge.indicatorOnly": "Nauja veikla",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Pasirinkite…",
  "picker.selectedCount": "{count, plural, =0 {Nepasirinktas nė vienas elementas} one {Pasirinktas # elementas} other {Pasirinkta elementų: #}}",
  "slider.maximum": "Daugiausia",
  "slider.minimum": "Mažiausia",
  "table.loading": "Įkeliama...",
  "table.loadingMore": "Įkeliama daugiau...",
  "table.resizeColumn": "Keisti stulpelio dydį",
  "table.sortAscending": "Rikiuoti didėjimo tvarka",
  "table.sortDescending": "Rikiuoti mažėjimo tvarka",
  "tag.actions": "Veiksmai",
  "tag.hideButtonLabel": "Rodyti mažiau",
  "tag.noTags": "Nėra",
  "tag.showAllButtonLabel": "Rodyti viską ({tagCount, number})",
  "toast.clearAll": "Išvalyti viską",
  "toast.collapse": "Sutraukti",
  "toast.showAll": "Rodyti viską"
}
